import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ContentManager from '../../components/admin/ContentManager';

export default function LinksPage() {
  return (
    <AdminLayout>
      <ContentManager
        title="Useful Links Management"
        subtitle="Manage external useful links"
        contentType="useful_links"
        fields={[
          { name: 'name', label: 'Link Name', type: 'text', required: true },
          { name: 'url', label: 'URL', type: 'text', required: true },
          { name: 'icon', label: 'Icon Name (Lucide)', type: 'text' },
          { name: 'priority', label: 'Priority', type: 'number', defaultValue: 10 },
          { name: 'is_active', label: 'Active', type: 'checkbox', defaultValue: true },
        ]}
        columns={['name', 'url', 'priority', 'is_active']}
      />
    </AdminLayout>
  );
}
